import { Box, Text, chakra } from "@chakra-ui/react";

const CheckEmailHeading = chakra(Text, {
  baseStyle: {
    fontWeight: "500",
    fontSize: { base: "24px", md: "40px" },
    marginTop: { base: "24px", md: "32px" },
    textAlign: "center",
  },
});

const CheckEmailDescription = chakra(Text, {
  baseStyle: {
    fontWeight: "400",
    fontSize: { base: "14px", md: "16px" },
    marginTop: { base: "12px", md: "18px" },
    textAlign: "center",
    color: "primary.grayText",
  },
});

const FormContainer = chakra(Box, {
  baseStyle: {
    width: { base: "full", md: "520px" },
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    paddingTop: '10px',
    pb: '40px'
  },
});
export { CheckEmailHeading, FormContainer, CheckEmailDescription };
